import React, { useState } from 'react';

import { HOST } from '../../constants/api';
import { headers } from '../../helpers/api';
import { humanUserRole } from '../../helpers/user';

import Badge from '../../components/Badge';
import Button from '../../components/Button';
import CollectionListing from '../../components/CollectionListing';
import FrameHeader from '../../components/FrameHeader';
import RowItem from '../../components/RowItem';
import Avatar from '../../components/Avatar';
import LoadingFrame from '../../components/LoadingFrame';

export default function AdminPortalLoginAs() {
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const handleLoginAs = async (userId) => {
        try {
            setIsLoggingIn(true);
            const response = await fetch(`${HOST}/users/${userId}/token`, {
                headers: headers(),
                credentials: "omit",
            });

            if (response.ok) {
                const token = await response.text();
                const cleanToken = token.replace(/^"|"$/g, '');
                console.log(cleanToken);
                window.localStorage.removeItem("refreshToken");
                window.localStorage.setItem("bearerToken", cleanToken);
                window.localStorage.setItem("refreshToken", cleanToken);

                // Reload the app to initialize state with the new user token
                window.location.replace("/");
            } else {
                alert("Failed to retrieve token for user.");
                setIsLoggingIn(false);
            }
        } catch (e) {
            console.error(e);
            alert("An error occurred during Login As.");
            setIsLoggingIn(false);
        }
    };

    if (isLoggingIn) {
        return <LoadingFrame text="Logging in..." />;
    }

    return (
        <>
            <FrameHeader title="Login As User">

            </FrameHeader>
            <CollectionListing
                collection="users"
                params={{ include_groups: 1 }}
                queryKey="email"
                item={u => (
                    <RowItem
                        key={u.id}
                        left={<Avatar name={`${u.first_name} ${u.last_name}`} />}
                        right={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                <Badge text={humanUserRole(u.authority)} />
                                <Button
                                    theme="primary"
                                    onClick={() => handleLoginAs(u.id)}
                                    autoFocus={false}
                                >
                                    Login As
                                </Button>
                            </div>
                        }
                        title={`${u.first_name} ${u.last_name}`}
                        subtitle={u.email + (u.customer ? ` - ${u.customer.name}` : '')}
                    />
                )}
            />
        </>
    );
}
